import api from '../index'

export const getAllTeamApi = (id) => api.post('getemployeelist', id);
export const AssignPermissionApi = (data) => api.post('add-permission-to-employee', data);
export const ChangeEmployeeStatusApi = (data) => api.post('update-user-status', data);

export const changeRoleApi = (data) => api.post('changeuserrole', data);
export const editEmployeeApi = (data) => api.post('edit-employee-profile', data); 
export const employeReport = (data) => api.post("employee-report", data);
